import React from "react";

/**
 * Compact calendar entry row: truncates with ellipsis and shows full text via native tooltip.
 * Use inside narrow calendar cells; parent should allow shrinking (minWidth: 0).
 */
export default function CalendarEntryChip({ title, onClick, className = "btn-link", style = {} }) {
  const full = title != null ? String(title) : "";
  return (
    <button
      type="button"
      onClick={onClick}
      className={className}
      title={full}
      style={{
        display: "block",
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        textAlign: "left",
        ...style,
      }}
    >
      {full}
    </button>
  );
}
